import React from 'react'
import ClubSubscriptionBody from '../../../components/AdminDashboard/ClubSubscription/ClubSubscriptionBody'
import SideNav from '../../../layouts/AdminDashboard/SideNav'

const ClubSubscription = () => {
    return (
        <div className='flex justify-end mobile:justify-start mobile:w-screen mobile:flex-col min-h-screen w-full mobile:bg-[#E5E5E5]'>
            
            {/* Side nav */}
            <SideNav />

            {/* Setting Body */}
            <ClubSubscriptionBody />

        </div>
    )
}

export default ClubSubscription